import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api, { createDecoder } from "../../api";
import { CargoType, cargoTypeT } from "dora-contracts";
import * as t from "io-ts";
import { isRight } from "fp-ts/Either";

const prefix = "app/cargo-types";

type State = {
  cargoTypes: CargoType[];
};

const initialState: State = {
  cargoTypes: [],
};

export const loadCargoTypes = createAsyncThunk(
  `${prefix}/load`,
  async (_, thunkAPI) => {
    const response = await api(thunkAPI).get({
      url: "/drivers-api/cargo-types",
      decoder: createDecoder(t.strict({ cargoTypes: t.array(t.string) })),
    });

    // Filter out cargo types that fail to decode
    const validCargoTypes = response.cargoTypes.filter((cargoType: string) => {
      const decoded = cargoTypeT.decode(cargoType);
      return isRight(decoded);
    }) as CargoType[];

    return { cargoTypes: validCargoTypes };
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    clearCargoTypes: (state) => {
      state.cargoTypes = initialState.cargoTypes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadCargoTypes.fulfilled, (state, action) => {
      state.cargoTypes = action.payload.cargoTypes;
    });
  },
});

export default slice.reducer;

export const { clearCargoTypes } = slice.actions;
